export default __webpack_public_path__ + "static/media/julian_sidepanel_empty.5f365273.svg";